/* eslint-disable import/prefer-default-export */
export const pageMetaInfo = {
  title: 'Learn with playlists',
  description:
    'Our curated playlists in IIT JEE of lessons from top educators are the perfect way to get the most out of your learning experience. Carefully selected and organised by subject matter experts, these playlists focus on the key concepts and skills you need to master.'
};
